module.exports = __webpack_public_path__ + "static/img/8.af18573.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/sp/8.png
// module id = NcGb
// module chunks = 0